import React, { useEffect } from 'react';
import {
    Route as ReactDOMRoute,
    RouteProps as ReactDOMRouteProps,
    Redirect,
} from 'react-router-dom';
import { useAuth } from '../hooks/auth';
import TopAppBar from '../components/layouts/TopAppBar/TopAppBar';
import { isAuthenticated, logout } from '../services/Auth';

function verifyToken()  {
    if (isAuthenticated() === false) {
        logout();
    }
}
interface RouteProps extends ReactDOMRouteProps {
    isPrivate?: boolean;
    component: React.ComponentType;
}
const Route: React.FC<RouteProps> = ({
    isPrivate = false,
    component: Component,
    ...rest
}) => {
    const { user, syncSuppliers} = useAuth();
    const path = "/Blank"//user ? user.permissions.filter(item => item === 'CONSULTAR_CLAIM').length > 0 ? '/OFP' : user.permissions.filter(item => item === 'RECEBER_MATERIAL').length > 0 ? '/ReceiveOFP' : user.permissions.filter(item => item === 'CONSULTAR_CAUSAL').length > 0 ? '/Causal' : '/Blank' : '/Blank';

    useEffect(() => {
        
        if (user && !user.isSupplierDetails)
            syncSuppliers();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Component])

    return (
        <>
            {isPrivate ? <TopAppBar hideMenu={false} hideCultureSelector={true} hideProfileMenu={true} hideCompanySelector={false} /> : <div />}
            <ReactDOMRoute
                {...rest}
                render={({ location }) => {
                    if (isPrivate)
                        verifyToken();
                    return isPrivate === !!user ? (
                        <Component />
                    ) : (
                            <Redirect
                                to={{
                                    pathname: isPrivate ? '/' : path,
                                    state: { from: location },
                                }}
                            />
                        );
                }}
            />
        </>
    );
};

export default Route;
